var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1GameConsole(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 19h-4c-2.3.15-4.22 1.68-4.86 5H27.86c-.64-3.3-2.56-4.83-4.86-5h-4C8.92 19 1.24 50.29 6.68 59.24a5.8 5.8 0 004.48 2.38 5.32 5.32 0 003-1 9 9 0 002.57-2.83c.1-.18.33-.66.33-.66L21.84 47h32.32l4.74 10.14s.23.48.33.66c1.49 2.46 3.48 3.82 5.61 3.82a5.8 5.8 0 004.48-2.38C74.76 50.29 69 19 57 19zM26 36h-4v4h-3v-4h-4v-3h4v-4h3v4h4v3zm22.38.5a2 2 0 110-4 2 2 0 010 4zm6 6a2 2 0 110-4 2 2 0 010 4zm0-12a2 2 0 110-4 2 2 0 010 4zm6 6a2 2 0 110-4 2 2 0 010 4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Game_console.1fc33876.svg";
export { SvgH1GameConsole as ReactComponent };